import React from 'react';
import { useEffect } from 'react';
import { handleMouseOverTooltip, hideTooltip } from '../../../data/utils';
import { ReactComponent as FullscreenIcon } from '../../../icons/dc.svg';
import { getLabel } from '../../../InitData';
import { useUISettings, useUISettingsDispatch } from '../../../UISettingsProvider';

export default function FullScreenButton() {
    const uiSettings = useUISettings();
    const dispatch = useUISettingsDispatch();

    function handleFullScreen() {
        dispatch({type: 'toggleFullscreen'});
    }

    useEffect(() => {
        return () => hideTooltip();
    }, []);

    return (
        <>
            {uiSettings.fullScreen ?
                <FullscreenIcon
                    className="margine-dx pointer tasto-collassa-sx ruota-180"
                    onClick={handleFullScreen}
                    onMouseOver={handleMouseOverTooltip}
                    onMouseOut={hideTooltip}
                    data-desc={getLabel('prematch_page.control_icon.fullscreen_off')}
                />
                :
                <FullscreenIcon
                    className="margine-dx pointer tasto-collassa-sx"
                    onClick={handleFullScreen}
                    onMouseOver={handleMouseOverTooltip}
                    onMouseOut={hideTooltip}
                    data-desc={getLabel('prematch_page.control_icon.fullscreen_on')}
                />
            }
        </>
    );
}
